<!--
 * @Author: your name
 * @Date: 2022-04-27 09:35:26
 * @LastEditTime: 2025-04-03 16:31:49
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jzjy\src\views\ActiveCenter\index.vue
-->
<template>
  <div id="container">
    <main>
        <div class="top">
            <div class="left">
                <div class="pic">
                    <img :src="file_url" alt="">
                </div>
                <div class="msg">
                    <div class="title"><h3>{{title}}</h3><img src="../../assets/img/5.0/tecStudio (3).png" alt=""></div>
                    <p>{{sub_title}}</p>
                </div>
            </div>
            <div class="right">
                <input type="text" placeholder="仅搜索本工作室资源" v-model="keyword" @keyup.enter="searchRes"/>
                <div class="anniu" @click="searchRes">
                    <h3>搜索</h3>
                </div>
            </div>
        </div>
        <div class="fenlei">
            <p>分类：</p>
            <span @click="choseFl(0)" :class="{chosedSpan:kejianfl_id == 0}">全部（{{all_num}}）</span>
            <span v-for="item in flLists" :key="item.kejianfl_id" :class="{chosedSpan:kejianfl_id == item.kejianfl_id}" @click="choseFl(item.kejianfl_id)">{{item.title}}（{{item.nums}}）</span>
        </div>
        <div class="banner">
            <img src="../../assets/img/5.0/tecStudio (6).png" alt="">
        </div>
        <div class="tuijian">
            <div class="tjBox" v-for="item in tj_res_list" :key="item.id">
                <div class="zytjBox" v-if="item.type_id == 1 || item.type_id == 2" @click="goresDetails(item.row_id, item.suffix,item.lx)">
                    <div class="pic" v-if="item.type_id == 2">
                            <img src="../../assets/img/ziyuanbaonew.png" />
                    </div>
                    <div class="pic" v-if="item.type_id == 1" style="width:59px;height: 67px;">
                        <img
                            src="../../assets/img/resFile (1).png"
                            alt="file_url"
                            v-if="
                            item.suffix == 'ppt' ||
                            item.suffix == 'pptx' ||
                            item.suffix == 'ppsx' ||
                            item.suffix == 'pps'
                            "
                        />
                        <img
                            src="../../assets/img/resFile (2).png"
                            alt="file_url"
                            v-if="item.suffix == 'mp4' || item.suffix == 'rm'"
                        />
                        <img
                            src="../../assets/img/resFile (3).png"
                            alt="file_url"
                            v-if="item.suffix == 'xls' || item.suffix == 'xlsx'"
                        />
                        <img
                            src="../../assets/img/resFile (4).png"
                            alt="file_url"
                            v-if="item.suffix == 'zip' || item.suffix == 'rar'"
                        />
                        <img
                            src="../../assets/img/resFile (5).png"
                            alt="file_url"
                            v-if="item.suffix == 'm4a' || item.suffix == 'mp3'"
                        />
                        <img
                            src="../../assets/img/resFile (6).png"
                            alt="file_url"
                            v-if="item.suffix == 'doc' || item.suffix == 'docx'"
                        />
                        <img
                            src="../../assets/img/resFile (7).png"
                            alt="file_url"
                            v-if="item.suffix == 'pdf'"
                        />
                        <img
                            src="../../assets/img/resFile (8).png"
                            alt="file_url"
                            v-if="item.suffix == 'png' || item.suffix == 'jpg'"
                        />
                    </div>
                    <div class="msg">
                        <h4>{{item.row_title}}</h4>
                        <div class="gzs">
                            <img src="../../assets/img/5.0/tecStudio (3).png" alt="">
                            <p>{{title}}</p>
                        </div>
                        <div class="date">
                            <span class="seeNum" v-if="item.type_id == 2"><i class="el-icon-view"></i>{{ item.view_nums }}</span>
                            <span class="upTime" >{{ timeStamp2String(item.update_time * 1000, 2) }}</span>
                            <span class="upTime" v-if="item.type_id == 2">内含{{ item.view_nums }}份资源</span>
                            <span class="upTime" v-if="item.type_id == 1">{{ item.viewCount }}</span>
                        </div>
                    </div>
                    <div class="tips">
                        <img src="../../assets/img/5.0/tecStudio (4).png" alt="">
                    </div>
                </div>
                <div class="hdtjBox" v-if="item.type_id == 3" @click="goActiveDetails(item.row_id)">
                    <div class="pic">
                            <img :src="item.file_url" />
                    </div>
                    <div class="msg">
                        <h4>{{item.row_title}}</h4>
                        <div class="gzs">
                            主讲专家：{{item.teachers_title}}
                        </div>
                        <div class="date">
                            <span class="upTime" >{{ timeStamp2String(item.start_time * 1000, 2) }}</span>
                        </div>
                    </div>
                    <div class="tips">
                        <img src="../../assets/img/5.0/tecStudio (4).png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="kejianlist">
            <div class="kejianBox" v-for="item in zyLists" :key="item.id">
                <div class="kejianfile">
                <img
                    src="../../assets/img/resFile (1).png"
                    alt="file_url"
                    v-if="
                    item.suffix == 'ppt' ||
                    item.suffix == 'pptx' ||
                    item.suffix == 'ppsx' ||
                    item.suffix == 'pps'
                    "
                />
                <img
                    src="../../assets/img/resFile (2).png"
                    alt="file_url"
                    v-if="item.suffix == 'mp4' || item.suffix == 'rm'"
                />
                <img
                    src="../../assets/img/resFile (3).png"
                    alt="file_url"
                    v-if="item.suffix == 'xls' || item.suffix == 'xlsx'"
                />
                <img
                    src="../../assets/img/resFile (4).png"
                    alt="file_url"
                    v-if="item.suffix == 'zip' || item.suffix == 'rar'"
                />
                <img
                    src="../../assets/img/resFile (5).png"
                    alt="file_url"
                    v-if="item.suffix == 'm4a' || item.suffix == 'mp3'"
                />
                <img
                    src="../../assets/img/resFile (6).png"
                    alt="file_url"
                    v-if="item.suffix == 'doc' || item.suffix == 'docx'"
                />
                <img
                    src="../../assets/img/resFile (7).png"
                    alt="file_url"
                    v-if="item.suffix == 'pdf'"
                />
                <img
                    src="../../assets/img/resFile (8).png"
                    alt="file_url"
                    v-if="item.suffix == 'png' || item.suffix == 'jpg'"
                />
                </div>
                <div class="msg">
                <div class="title" @click="goresDetails(item.id, item.suffix)">
                    <img src="../../assets/img/ffzyb/vip.png" v-show="item.is_sf == 1" >
                    <span v-if="item.is_tj == 1 && item.is_sf != 1">精选</span>{{ item.title }}
                </div>
                <p v-html="item.sub_info" v-if="item.lx == 2" ></p>
                <span v-if="item.lx == 2">......</span>
                <div class="bottom">
                    <div class="gzs">
                        <img src="../../assets/img/5.0/tecStudio (3).png" alt="">
                        <div class="gzsTitle">{{item.starteacherstudio_title}}</div>
                    </div>
                    <span class="seeNum" v-if="!item.lx || item.lx == 1"
                    ><i class="el-icon-view"></i>{{ item.viewCount }}</span
                    >
                    <span class="seeNum" v-if="item.lx == 2"
                    ><i class="el-icon-view"></i>{{ item.view_nums }}</span
                    >
                    <span class="upTime">
                    {{ timeStamp2String(item.update_time * 1000, 2) }}
                    </span>
                </div>
                </div>
                <div class="kejianright">
                    <div class="downLoad" @click="goresDetails(item.id, item.suffix)">查看全部</div>
                    <div class="soucang" @click="sckj(item.id)" v-if="item.sc_status == 0"><img src="../../assets/img/tbsc1.png"><p>加入收藏</p></div>
                    <div class="soucang" @click="qxsc(item.id)" v-if="item.sc_status == 1" style="color:#1E60EB"><img src="../../assets/img/5.0/ziyuan (3).png"><p>已收藏</p></div>
                    <div class="money" v-if="item.is_sf == 1"><p>￥{{item.price}}</p><span>收费</span></div>
                    <!-- <div class="money" v-if="item.is_sf == 1 && item.gm_status == 0"><img src="../../assets/img/money.png">付费资源</div>
                    <div class="money" v-if="item.is_sf == 1 && item.gm_status == 1"><img src="../../assets/img/money.png">已解锁</div> -->
                </div>
            </div>
        </div>
        <div class="page page2" v-if="zyLists.length > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            background
            :page-sizes="[5, 10, 15]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="counts"
          >
          </el-pagination>
        </div>
    </main>
  </div>
</template>

<script>
import { timeStamp2String } from "../../utils/time";
import {
  userinfo,
  info_starteacherstudio,
  list_starteacherstudio_res,
  islogin,
  create_accountzysc,
  list_kejian,
} from "../../api/http";
export default {
  inject: ["reload"],
  metaInfo () {
    return {
      title: '精准教研教学平台-专注教师教研与教学服务，助力教师专业提升！',
       meta: [{ 
        name: 'Keywords',
        content: '教研教学平台,教学资源,同步教研,课件下载,同步课件,备课资源,教师培训,教师研修,人教版课件,在线教研,新高考'
      }, {
        name: 'description',
        content: '精准教研教学平台是一个专门为全国高中教师打造的教研教学服务平台，侧重高中教材同步精品资源下载（课件、教案、学案、试卷、素材、练习等）、体系化公益教研活动直播、专家名师工作室优质资源共享等。精准定位教学需求，助力提升教学水平，是高中教师随时随地的教研教学小助手。'
      }],
    }
  },
  data() {
    return {
      timeStamp2String,
      nowKm:1,//当前页面的科目，未登录默认语文
      login_status:'',
      file_url:'',//工作室头像
      title:"",
      sub_title:'',
      keyword: "",//搜索框关键字
      all_num:0,
      tj_res_list:[],
      zyLists:[],
      currentPage:1,
      counts:0,
      flLists:[],
      type_id:0,
      kejianfl_id:0,
      page:1,
      page_size:5,
    };
  },
  components: {},
  created() {
    
    this.getDetails();
    this.getLists();
    this.getFl();
    
    
    //回到顶部
    $(document).ready(function () {
      $(window).scrollTop(0);
    });
    this.timeNow = Date.now();

    // islogin().then(res=>{
    //   this.login_status = res.retRes.login_status;
    //   if(this.login_status == 1){
    //     //判断过期
    //     userinfo({
    //       md5key: localStorage.getItem("md5key"),
    //     }).then((res) => {
    //       if (res.retRes.sy_end_time * 1000 < Date.parse(new Date())) {
    //         this.$router.push({
    //           name: "Login",
    //           query: {
    //             isgq: 1,
    //           },
    //         });
    //       } else {
    //         const data = res.retRes;
    //         this.file_url = data.file_url;
    //         this.radio1 = this.kemu_id = data.kemu_id;
    //         this.kejianversions_id = data.kejianversions_id;
    //         this.nianji_id = data.nianji_id;
    //       }
    //     });
    //   }
    // })
    
  },
  mounted() {
    //重定向
    localStorage.setItem("path", "");
  },
  beforeDestroy() {
  },
  methods: {
    //获取
    getDetails() {
      info_starteacherstudio({
        md5key: localStorage.getItem("md5key"),
        id:this.$route.query.id,
      }).then(res=>{
        const data = res.retRes;
        this.file_url = data.file_url;
        this.title = data.title;
        this.sub_title = data.sub_title;
        if(data.tj_res_list.length >= 2){
            this.tj_res_list = data.tj_res_list.slice(0,2);
        }else{
            this.tj_res_list = data.tj_res_list;
        }
      })
    },
    getLists(){
        list_starteacherstudio_res({
            md5key: localStorage.getItem("md5key"),
            id:this.$route.query.id,
            // type_id:this.type_id,
            kejianfl_id:this.kejianfl_id,
            title:this.keyword,
            page:this.page,
            page_size:this.page_size,
        }).then(res=>{
            this.counts = res.retCounts;
            const data = res.retRes;
            this.zyLists = data;
        })
    },
    //获取分类
    getFl(){
        list_kejian({
            md5key: localStorage.getItem("md5key"),
            starteacherstudio_id:this.$route.query.id,
            get_fl:1
        }).then(res=>{
            const data = res.retRes;
            this.flLists = res.retRes;
            this.all_num = 0
            data.forEach(item=>{
                this.all_num = this.all_num + item.nums
            })
        })
    },
    choseFl(e){
        if(e == 0){
            this.kejianfl_id = ''
            this.page = 1;
            this.currentPage = 1;
            this.getLists();
        }else{
            this.kejianfl_id = e
            this.page = 1;
            this.currentPage = 1;
            this.getLists();
        }
        
        
    },
    searchRes() {
      this.page = 1;
      this.kejianfl_id = 0;
      this.getLists();
      this.keyword = "";
    },
    //去活动详情
    goActiveDetails(id, type) {
      let { href } = this.$router.resolve({
        path: "/active/fullScreen",
        query: {
          id: id,
          type: 'hd',
          from: "活动中心",
        },
      });
      window.open(href, "activeRes");
    },
    //点击课件前往课件详情
    goresDetails(id, suffix,lx) {
        if(!lx){
            if (suffix != "rar" && suffix != "zip") {
                let { href } = this.$router.resolve({
                    path: "/resource/resDetails",
                    query: { id: id},
                });
                window.open(href, "_blank");
            } else if (suffix == "rar" || suffix == "zip") {
                let { href } = this.$router.resolve({
                    path: "/resource/zipResDetails",
                    query: { id: id},
                });
                window.open(href, "_blank");
            }
        }else{
            let { href } = this.$router.resolve({
                path: "/resource/beikeziyuan",
                query: { id: id},
            });
            window.open(href, "_blank");
        }
        
    },
    //收藏
    sckj(id){
      const scarr = []
      scarr.push(id)
      create_accountzysc({
        md5key: localStorage.getItem("md5key"),
        ids:scarr,
        type_id: 1,
        status: 1,
      }).then(res=>{
        if(res.retInt == 1){
          this.getLists();
        }
      })
    },
    //取消收藏
    qxsc(id){
      const qxscarr = []
      qxscarr.push(id)
      create_accountzysc({
        md5key: localStorage.getItem("md5key"),
        ids:qxscarr,
        type_id: 1,
        status: 2,
      }).then(res=>{
        if(res.retInt == 1){
          this.getLists();
        }
      })
    },
    //分页
    handleSizeChange(val) {
      this.page_size = val;
      this.page = 1;
      this.currentPage = 1;
      this.getLists();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
  },
};
</script>
<style>


/* 用于分页 */
.el-select-dropdown__item.selected {
  color: #1E60EB !important;
}
.el-pagination__editor.el-input .el-input__inner {
  border-color: #ccc;
}
.page1 {
  width: 720px;
  margin: 0 auto;
}
.el-pagination {
  text-align: center;
  margin: 20px 80px 20px 0;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #1E60EB !important;
}
.el-pagination .el-select .el-input .el-input__inner:hover {
  border-color: #1E60EB !important;
}
.el-select .el-input__inner:focus {
  border-color: #1E60EB !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1E60EB !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff;
}
.el-pager li:hover {
  color: #1E60EB !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff !important;
}
</style>
<style lang="less" scoped>
#container {
  background-color: #f0f2f5;
  main {
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 1200px;
    background-color: #FFFFFF;
    overflow: hidden;
    .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        width: 1200px;
        height: 140px;
        background: #FFFFFF;
        // border-radius: 10px;
        // border-bottom: 1px solid #E6E6E6;
        background-image: url('../../assets/img/5.0/mingshibg.png');
        background-size:100% 100%;
        background-repeat: no-repeat;
        .left{
            display: flex;
            margin-left: 40px;
            .pic{
                margin-right: 20px;
                width: 100px;
                height: 100px;
                border-radius: 50%;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .msg{
                margin-top: 4px;
                .title{
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;
                    h3{
                        font-size: 20px;
                        color: #333333;
                    }
                    img{
                        margin-left: 8px;
                        width: 16px;
                        height: 16px;
                    }
                }
                p{
                    font-size: 16px;
                    color: #999999;
                }
            }
        }
        .right {
            display: flex;
            align-items: center;
            position: relative;
            margin-left: 55px;
            margin-right: 40px;
            user-select: none;
            width: 280px;
            input {
                padding-left: 20px;
                width: 240px;
                height: 37px;
                border: 1px solid #1E60EB;
                border-radius: 6px;
                outline: none;
            }
            .anniu {
                position: absolute;
                right: 2px;
                top: 0px;
                background-color: #1E60EB;
                border-top-right-radius: 5px;
                cursor: pointer;
                border-bottom-right-radius: 5px;
                width: 60px;
                height: 39px;
                text-align: center;
                line-height: 40px;
                color: #FFF;
            }
        }
    }
    .fenlei{
        display: flex;
        align-items: center;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 1120px;
        height: 68px;
        background: #F5F7FA;
        border-radius: 10px;
        p{
            margin: 0 18px;
            font-size: 14px;
        }
        span{
            cursor: pointer;
            padding: 6px 18px;
            font-size: 14px;
        }
        .chosedSpan{
            border-radius: 2px;
            background: #E6ECFA;
            color: #1E60EB;
        }
    }
    .banner{
        margin: 0 auto;
        // margin-bottom: 20px;
        width: 1120px;
        height: 54px;
        border-radius: 10px;
    }
    .tuijian{
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin-bottom: 25px;
        .tjBox{
           .zytjBox{
                display: flex;
                align-items: center;
                position: relative;
                width: 550px;
                height: 120px;
                background: #F5F7FA;
                border-radius: 10px;
                cursor: pointer;
                .pic{
                    margin-left: 30px;
                    width: 60px;
                    height: 60px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .msg{
                    position: relative;
                    margin-left: 28px;
                    width: 340px;
                    height: 120px;
                    h4{
                        margin-top: 18px;
                        margin-bottom: 6px;
                        font-size: 14px;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;  // 控制多行的行数
                        -webkit-box-orient: vertical;
                    }
                    .gzs{
                        display: flex;
                        align-items: center;
                        
                        img{
                            position: relative;
                    right: -4px;
                            width: 16px;
                            height: 16px;
                        }
                        p{
                            display: inline-block;
                            padding: 2px 6px;
                            height: 16px;
                            background: #E6ECFA;
                            border-radius: 2px;
                            color: #1E60EB;
                        }
                    }
                    .date{
                        position: absolute;
                        bottom:15px;
                        // margin-top: 28px;
                        color: #939599;
                        .seeNum{
                            margin-right: 20px;
                            i{
                                margin-right: 5px;
                            }
                        }
                        .upTime{
                            margin-right: 20px;
                            i{
                                margin-right: 5px;
                            }
                        }
                    }
                }
                .tips{
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    width: 56px;
                    height: 64px;
                }
            } 
            .hdtjBox{
                display: flex;
                align-items: center;
                position: relative;
                width: 550px;
                height: 120px;
                background: #F5F7FA;
                border-radius: 10px;
                cursor: pointer;
                .pic{
                    margin-left: 10px;
                    width: 188px;
                    height: 100px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .msg{
                    position: relative;
                    margin-left: 16px;
                    width: 240px;
                    height: 120px;
                    h4{
                        margin-top: 18px;
                        margin-bottom: 6px;
                        font-size: 14px;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;  // 控制多行的行数
                        -webkit-box-orient: vertical;
                    }
                    .gzs{
                        color: #939599;
                    }
                    .date{
                        position: absolute;
                        bottom:15px;
                        // margin-top: 28px;
                        color: #939599;
                    }
                }
                .tips{
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    width: 56px;
                    height: 64px;
                }
            } 
        }
        .tjBox:first-of-type{
            margin-left: 40px;
        }
        .tjBox:last-of-type{
            margin-right: 40px;
        }
    }
    //课件类资源样式
    .kejianlist {
        margin: 0 auto; 
        width: 1120px;
        // height: 800px;
        -ms-overflow-style: none; /* IE 10+ */
        scrollbar-width: none; /* Firefox */
        overflow-y: scroll;
        .kejianBox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px dashed #e6e6e6;
            cursor: pointer;
            .kejianfile {
            margin-left: 40px;
            text-align: center;
            // width: 140px;
            // height: 140px;
            // background: linear-gradient(0deg, #e6e6e6, #ffffff);
            // border: 1px solid #ededed;
            img {
                width: 60px;
                height: 68px;
                vertical-align: text-bottom;
            }
            }
            .msg {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 40px;
            height: 68px;
            border-right: 1px solid #e6e6e6;
            cursor: pointer;
            .title {
                width: 635px;
                font-size: 16px;
                font-weight: 900;
                color: #333;
                overflow: hidden;
                white-space: wrap;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3; /*想省略几行就写几*/
                -webkit-box-orient: vertical;
                img{
                position: relative;
                top: 5px;
                margin-right: 8px;
                width: 36px;
                }
                span {
                display: inline-block;
                margin-right: 4px;
                text-align: center;
                color: #FFF;
                line-height: 20px;
                font-size: 12px;
                width: 40px;
                height: 20px;
                border-radius: 4px;
                background: #E63F3F;
                }
            }
            p {
                width: 480px;
                // min-height: 80px;
                line-height: 20px;
                font-size: 13px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
            }
            .bottom {
                display: flex;
                align-items: center;
                // position: relative;
                // top: 80px;
                font-size: 12px;
                color: #999;
                .upTime {
                margin-left: 38px;
                }
                .seeNum {
                i {
                    margin-right: 5px;
                }
                }
                .rate {
                display: flex;
                margin-right: 38px;
                width: 148px;
                }
                /deep/.el-rate__icon {
                margin-right: 0;
                }
                .gzs{
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    img{
                        width: 16px;
                        height: 16px;
                    }
                    .gzsTitle{
                        display: inline-block;
                        padding: 2px 6px;
                        height: 16px;
                        line-height: 16px;
                        background: #E6ECFA;
                        border-radius: 2px;
                        color: #1E60EB;
                    }
                }
            }
            }
            .kejianright{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 80px;
                .downLoad {
                    margin-bottom: 10px;
                    width: 96px;
                    height: 28px;
                    color: #fff;
                    text-align: center;
                    line-height: 28px;
                    background: #1E60EB;
                    border-radius: 14px;
                    background: #1E60EB;
                    border-radius: 14px;
                    cursor: pointer;
                }
                .soucang{
                    display: flex;
                    align-items: center;
                    color: #666;
                    img{
                        margin-right: 6px;
                        width: 12px;
                    }
                }
                .money{
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    color: #E63F3F;
                    span{
                        display: inline-block;
                        width: 32px;
                        height: 16px;
                        background: #FDE8E8;
                        border-radius: 2px;
                        text-align: center;
                        line-height: 16px;
                        font-size: 12px;
                    }
                }
            }
            .jiaoyan {
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;
            // padding: 30px 0 10px 0;
            width: 1200px;
            .box {
                position: relative;
                margin-left: 20px;
                margin-bottom: 30px;
                background-color: #fff;
                border-radius: 10px;
                cursor: pointer;
                img {
                margin-bottom: 10px;
                width: 240px;
                height: 136px;
                border-radius: 10px;
                }
                .activename {
                margin-bottom: 18px;
                width: 240px;
                font-size: 14px;
                color: #333333;
                }
                p {
                position: absolute;
                bottom: -5px;
                font-size: 12px;
                color: #939599;
                }
            }
            .box:hover {
                // transition: 1s;
                img {
                transition: 0.5s;
                // position: relative;
                // top: -10px;
                transform: translateY(-10px);
                box-shadow: 0px 2px 10px 2px #dedede;
                }
                .activename {
                color: #1E60EB;
                }
            }
            }
        }
    }
    .page2 {
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 20px;
    }
  }
}
</style>
